export default __webpack_public_path__ + "static/media/nmcp.8f6ae621.png";